import Vue from 'vue'
import Router from 'vue-router'

import OnePage from '@/views/onepage/frame'

import Error from '@/views/error'

import DocumentsConduct from '@/views/documents/conduct'
import DocumentsImprint from '@/views/documents/imprint'
import DocumentsPrivacy from '@/views/documents/privacy'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 0 }
      }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      component: OnePage
    },
        {
          path: '/satzung',
          component: DocumentsConduct
        },
        {
          path: '/datenschutz',
          component: DocumentsPrivacy
        },
        {
          path: '/impressum',
          component: DocumentsImprint
        },
    {
      path: '*',
      component: Error
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js